<template>
  <div>
    <el-table
      ref="table"
      :data="tableData"
      v-loading="loading"
      size="small"
      :height="height"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="categoryName"
        :label="'分类名称'"
        width="100"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="priceRange"
        :label="'价格范围'"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="spec"
        :label="'产品规格'"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="testingProtocol"
        :label="'测试规则'"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="moq"
        :label="'最低起订量'"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="styles"
        :label="'款式'"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        :label="'修改信息'"
        width="200"
      >
        <template slot-scope="scope">
          <div>修改人:{{ scope.row.modifyByName }}</div>
          <div>修改时间:{{ scope.row.modifyDate }}</div>
        </template>
      </el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ '暂无数据!' }}</p>
        </div>
      </div>
      <el-table-column :label="'操作'" width="100">
        <template slot-scope="scope">
          <el-button
            v-if="!disabled"
            size="mini"
            style="padding:5px;"
            @click="fromLoad('edit', scope.row.custLabelCode)"
            icon="el-icon-edit-outline"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
    params: {
      default: null,
      type: Object,
    },
    height: {
      default: 272,
      type: Number,
    },
  },
  components: {},
  data() {
    return {
      // 表单设置
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
      // 选中的数据
      multipleSelection: [],
    }
  },
  methods: {
    // 加载表单
    fromLoad(ref, val = '') {
      this.$refs.labels.load(ref, val)
    },
  },
}
</script>
